<template>
  <div v-style="brandStyles.container" :class="brandClasses.container">
    <p aria-live="polite" :class="brandClasses.label">
      {{ replaceAll(previousPage || nextPage ? $t.viewingPage : $t.viewingProducts, { current, total }) }}
    </p>
    <vf-progress-bar v-if="showProgressBar" class="mx-a" :max="total" :value="current" />
    <div v-if="previousPage || nextPage" :class="{ 'grid cols-2 gap-2': previousPage && nextPage }">
      <vf-button
        v-if="previousPage"
        :class="brandClasses.cta"
        :size="buttonSize"
        :to="getPaginationQueryParams(previousPage)"
        :variant="previousNextVariant"
        @click="$emit('previous', previousPage)"
      >
        {{ $t.previous }}
      </vf-button>
      <vf-button
        v-if="nextPage"
        :class="brandClasses.cta"
        :size="buttonSize"
        :to="getPaginationQueryParams(nextPage)"
        :variant="previousNextVariant"
        @click="$emit('next', nextPage)"
      >
        {{ $t.next }}
      </vf-button>
    </div>
    <vf-button
      v-else-if="current < total"
      id="viewMoreCTA"
      :class="brandClasses.cta"
      role="button"
      :size="buttonSize"
      :to="getPaginationQueryParams(2)"
      @click.prevent.capture="$emit('load-more')"
    >
      {{ $t.viewMore }}
      <span v-if="showPageSize && pageSize">&nbsp;({{ pageSize }})</span>
    </vf-button>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  /**
   * Current number of products shown
   */
  current: number
  /**
   * Number of products in next page
   */
  pageSize?: number
  /**
   * Total number of products
   */
  total: number
  previousPage?: number
  nextPage?: number
}>()

defineEmits<{
  'load-more': []
  'next': [page: number]
  'previous': [page: number]
}>()

const {
  brandClasses,
  brandStyles,
  buttonSize,
  previousNextVariant,
  showPageSize,
  showProgressBar
} = useAppConfig().components.product.pagination
const route = useRoute()

const getPaginationQueryParams = (page: number) => {
  const params = { ...route.query, page: page.toString() }
  return params ? `?${new URLSearchParams(params).toString()}` : undefined
}
</script>
